module.exports = __webpack_public_path__ + "images/history-cat-4-c7dddf68682ff59f2d0bda0b728ead4f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/history-cat-4.png
 ** module id = 391
 ** module chunks = 0
 **/